import './DatasetCard.css';
// import DatasetModal2 from './DatasetModal2.js';
import DatasetTableauLinkModal from './DatasetTableauLinkModal.js';
import Button from 'react-bootstrap/Button';
import { useState } from 'react';


function PetroleumImports(props) {

    const [isHovering, setIsHovering] = useState(false);
    const [modalIsOpen, setModalOpen] = useState(false);

    const handleMouseOver = () => {
        setIsHovering(true);
    }

    const handleMouseOut = () => {
        setIsHovering(false);
    }

    const handleModalOpen = () => {
        setModalOpen(true);
    }

    const handleModalClose = () => {
        setModalOpen(false);
    }

    // Why are we passing all the fields in metadataObject and then sometimes also in plain ole props. Its a bad idea. Just use props next time.
    const { datasetName, chartPackageDate, domain, filename, schema_filename, allProps} = props.metadataObject;
    const { tableauURL, thumbnailURL, modalThumbnailURL } = allProps;
    const titleColor = isHovering ? '#F2AE00' : '#05436E';

    const metadataDescription = () => {
        return (
            <div>
                This visualization is available to view and interact with on <a target="_blank" href={tableauURL}>Tableau Public</a>.
            </div>
        );
    }

    // const metadataLinks= () => {
    //     return (
    //         <div>
    //             Download Dataset:
    //             {/* <a className='data-file-link' href={`https://d1c48g3icd9ay6.cloudfront.net/${domain}/${filename}`}> */}
    //             <a className='data-file-link' href={`datasets/${domain}/${filename}`}>
    //                 <span style={{ fontSize: "1.5em" }}>
    //                     &nbsp;<i className='bi bi-filetype-csv'></i>
    //                 </span>
    //             </a>
    //             <br/>
    //             Dataset Schema Definition:
    //             <a className='data-file-link' href={`datasets/${domain}/${schema_filename}`}>
    //                 <span style={{ fontSize: "1.5em" }}>
    //                     &nbsp;<i className='bi bi-filetype-csv'></i>
    //                 </span>
    //             </a>
    //         </div>
    //     );
    // }

    const metadataLinks= () => {
        return (
            <div>
                Source: U.S. Energy Information Administration (<a target="_blank" href="https://www.eia.gov/opendata/browser/crude-oil-imports">https://www.eia.gov/opendata/browser/crude-oil-imports</a>)
            </div>
        );
    }





    return (
        <>
            <div
                style={{ 
                    background: '#fff', padding: '4px', marginBottom: '12px'
                }}
            >
                <div style={{height: '436px', width: '95%', marginBottom: '10px', marginLeft: '5px'}}>

                
                <Button className='dataset-modal-open' onClick={handleModalOpen} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
                    <h6 className='dataset-card-title' style={{ color: titleColor }}>
                        {datasetName} {chartPackageDate ? `(${chartPackageDate})` : ''}
                    </h6>&nbsp;
                    {isHovering && <i className='las la-hand-pointer' style={{ fontSize: '0.85em', verticalAlign: 'center', color: titleColor }}></i>}
                </Button>
                    {/* <div className="image-container">
                    <img className="responsive-image" src={tableauURLs['thumbnailURL']} alt="State Fleet Electrification for Vehciles greater than 8,000 lbs by fiscal year"></img>
                    </div> */}
                    <div className="image-container" style={{ backgroundImage: `url(${thumbnailURL})`, }}></div>
                    {/* The small thumbnail is best as a 430x380px png. The larger modal image space is 1000x400px but you dont have to use it all. */}

                {/* <div style={{height: '400px', width: '95%', marginBottom: '10px', marginLeft: '5px', padding: '10px 0 0 30px'}}>
                </div> */}

                <DatasetTableauLinkModal
                    modalThumbnailURL={modalThumbnailURL}
                    tableauURL={tableauURL}
                    show={modalIsOpen}
                    handleClose={handleModalClose} 
                    metadata={props.metadataObject}
                    domain={domain}
                    filename={filename}
                    schema_filename={schema_filename}
                    metadataLinks={metadataLinks()}
                    metadataDescription={metadataDescription()}
                ></DatasetTableauLinkModal>

                </div>
            </div>
        </>
    );
}


export default PetroleumImports;